import { render, staticRenderFns } from "./TeamsDetail.vue?vue&type=template&id=06ef409a"
import script from "./TeamsDetail.vue?vue&type=script&lang=js"
export * from "./TeamsDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports